import api from '../../../api.js';

export const types = {
  START_LOADING_ARTICLE: 'Blog/startLoadingArticle',
  START_LOADING_ARTICLES: 'Blog/startLoadingArticles',
  START_LOADING_CATEGORIES: 'Blog/startLoadingCategories',
  START_LOADING_TAGS: 'Blog/startLoadingTags',
  STOP_LOADING_ARTICLE: 'Blog/stopLoadingArticle',
  STOP_LOADING_ARTICLES: 'Blog/stopLoadingArticles',
  STOP_LOADING_CATEGORIES: 'Blog/stopLoadingCategories',
  STOP_LOADING_TAGS: 'Blog/stopLoadingTags',
  SET_CURRENT_ARTICLE: 'Blog/setCurrentArticle',
  SET_CATEGORIES: 'Blog/setCategories',
  SET_TAGS: 'Blog/setTags',
  SET_ARTICLES: 'Blog/setArticles',
  REMOVE_ARTICLES: 'Blog/removeArticles',
  SET_PREV_ARTICLE: 'Blog/setPrevArticle',
  SET_NEXT_ARTICLE: 'Blog/setNextArticle',
  CANCEL_LOADER: 'Blog/cancelLoader',
};

export function startLoadingArticle() {
  return {
    type: types.START_LOADING_ARTICLE
  };
}

export function startLoadingArticles() {
  return {
    type: types.START_LOADING_ARTICLES
  };
}

export function startLoadingCategories() {
  return {
    type: types.START_LOADING_CATEGORIES
  };
}

export function startLoadingTags() {
  return {
    type: types.START_LOADING_TAGS
  };
}

export function cancelLoader() {
  return {
    type: types.CANCEL_LOADER,
  };
}

export function stopLoadingArticle() {
  return {
    type: types.STOP_LOADING_ARTICLE
  };
}

export function stopLoadingArticles() {
  return {
    type: types.STOP_LOADING_ARTICLES
  };
}

export function stopLoadingCategories() {
  return {
    type: types.STOP_LOADING_CATEGORIES
  };
}

export function stopLoadingTags() {
  return {
    type: types.STOP_LOADING_TAGS
  };
}

export function setCurrentArticle(article) {
  return {
    type: types.SET_CURRENT_ARTICLE,
    article
  };
}

export function setCategories(categories) {
  return {
    type: types.SET_CATEGORIES,
    categories
  };
}

export function setTags(tags) {
  return {
    type: types.SET_TAGS,
    tags
  };
}

export function setArticles(articles) {
  return {
    type: types.SET_ARTICLES,
    articles
  };
}

export function removeArticles() {
  return {
    type: types.REMOVE_ARTICLES
  };
}

export function setPrevArticle(prevArticle) {
  return {
    type: types.SET_PREV_ARTICLE,
    prevArticle
  }
}

export function setNextArticle(nextArticle) {
  return {
    type: types.SET_NEXT_ARTICLE,
    nextArticle
  }
}

export function loadCategories() {
  return async (dispatch, getState) => {
    if (!getState().blog.categories.length) {
      dispatch(startLoadingCategories());

      try {
        const response = await api.blog.getCategories();
        dispatch(setCategories(response.data));
        return response.data;
      } catch(e) {
        console.warn(e);
      } finally {
        dispatch(stopLoadingCategories());
      }
    }
  }
}

export function loadTags() {
  return async (dispatch, getState) => {
    if (!getState().blog.tags.length) {
      dispatch(startLoadingTags());

      try {
        const response = await api.blog.getTags();
        dispatch(setTags(response.data));
        return response.data;
      } catch(e) {
        console.warn(e);
      } finally {
        dispatch(stopLoadingTags());
      }
    }
  }
}

export function loadArticles() {
  return async (dispatch) => {
    dispatch(startLoadingArticles());

    try {
      const response = await api.blog.articles.getAll();
      dispatch(setArticles(response.data));
      return response.data;
    } catch(e) {
      console.warn(e);
    } finally {
      dispatch(stopLoadingArticles());
    }
  }
}

export function loadArticle(slug) {
  return async (dispatch, getState) => {
    dispatch(startLoadingArticle());
    if (!getState().blog.articles.length) {
      await dispatch(loadArticles());
    }
    const articles = getState().blog.articles;

    for (let i = 0; i < articles.length; i++) {
      if (articles[i].slug === slug) {
        await dispatch(setCurrentArticle(articles[i]));
        await dispatch(setPrevAndNextArticles(i));
      }
    }
    dispatch(stopLoadingArticle());
  }
}

export function setPrevAndNextArticles(index) {
  return async (dispatch, getState) => {
    const articles = getState().blog.articles;
    if (index <= 0) {
      dispatch(setPrevArticle(null));
      dispatch(setNextArticle(articles[1]));
    } else if (index >= (articles.length - 1)) {
      dispatch(setPrevArticle(articles[index-1]));
      dispatch(setNextArticle(null));
    } else {
      dispatch(setPrevArticle(articles[index-1]));
      dispatch(setNextArticle(articles[index+1]));
    }
  }
}

export default {
  startLoadingArticle,
  startLoadingArticles,
  startLoadingCategories,
  startLoadingTags,
  stopLoadingArticle,
  stopLoadingArticles,
  stopLoadingCategories,
  stopLoadingTags,
  setCurrentArticle,
  setArticles,
  removeArticles,
  loadCategories,
  loadTags,
  loadArticle,
  loadArticles,
  cancelLoader,
};